(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.promotionSlider = {
        attach: function (context) {
            const slider = once('promotion-slider', '.promo-slider__items .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const DESKTOP_BREAKPOINT = 992;
            const sliderContainer = slider.closest('.card-slider__items') || slider.closest('.promo-slider__items') || slider.parentElement;
            const pagination = slider.querySelector('.swiper-pagination') || (sliderContainer && sliderContainer.querySelector('.swiper-pagination'));
            const prevEl = (sliderContainer && sliderContainer.querySelector('.swiper-button-prev')) || slider.querySelector('.swiper-button-prev');
            const nextEl = (sliderContainer && sliderContainer.querySelector('.swiper-button-next')) || slider.querySelector('.swiper-button-next');

            const slideCount = slider.querySelectorAll('.swiper-slide').length;

            const toggleControls = (width) => {
                if (!prevEl && !nextEl && !pagination) {
                    return;
                }

                if (width < 768) {
                    if (prevEl) prevEl.style.display = 'none';
                    if (nextEl) nextEl.style.display = 'none';
                    if (pagination) pagination.style.display = 'block';
                    return;
                }

                if (width >= 768 && width < DESKTOP_BREAKPOINT) {
                    if (prevEl) prevEl.style.display = 'none';
                    if (nextEl) nextEl.style.display = 'none';
                    if (pagination) pagination.style.display = 'block';
                    return;
                }

                if (width >= DESKTOP_BREAKPOINT) {
                    if (slideCount <= 3 || (width >= 992 && width < 1200)) {
                        if (prevEl) prevEl.style.display = 'none';
                        if (nextEl) nextEl.style.display = 'none';
                        if (pagination) pagination.style.display = 'block';
                        return;
                    }

                    if (prevEl) prevEl.style.display = 'flex';
                    if (nextEl) nextEl.style.display = 'flex';
                    if (pagination) pagination.style.display = 'block';
                    return;
                }
            };

            let swiperInstance = null;

            const buildOptions = () => {
                const width = window.innerWidth;

                let slidesPerView = 'auto';
                let centeredSlides = false;
                let loop = (width < DESKTOP_BREAKPOINT);

                if (width >= 768 && width < DESKTOP_BREAKPOINT) {
                    slidesPerView = 1.5;
                    centeredSlides = false;
                    loop = true;
                }

                if (width >= DESKTOP_BREAKPOINT) {
                    slidesPerView = 2;
                    centeredSlides = false;
                    loop = true;
                }

                if (slideCount === 1) {
                    centeredSlides = true;
                    slidesPerView = 1;
                    loop = true;
                }

                return {
                    enabled: true,
                    slidesPerView: slidesPerView,
                    spaceBetween: 16,
                    slidesOffsetBefore: 5,
                    slidesOffsetAfter: 5,
                    loop: loop,
                    centeredSlides: centeredSlides,
                    pagination: {
                        el: pagination || undefined,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: nextEl || undefined,
                        prevEl: prevEl || undefined,
                    },
                    breakpoints: Object.assign({}, {
                        768: {
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 16,
                        }
                    }, {
                        1200: {
                            slidesPerView: 3,
                            centeredSlides: false,
                            spaceBetween: 16,
                            loop: false,
                        }
                    })
                };
            };

            const initSlider = () => {
                if (swiperInstance) {
                    return;
                }

                try {
                    swiperInstance = new Swiper(slider, buildOptions());
                    slider.classList.add('is-swiper-active');
                    // Remove any disabled wrapper class when the slider is active
                    const wrapper = slider.querySelector('.swiper-wrapper');
                    if (wrapper) {
                        wrapper.classList.remove('swiper-wrapper--disabled');
                    }
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                    swiperInstance = null;
                }
            };

            const destroySlider = () => {
                if (!swiperInstance) {
                    return;
                }

                swiperInstance.destroy(true, true);
                swiperInstance = null;
                slider.classList.remove('is-swiper-active');
                // When destroying, mark wrapper so CSS can apply a gap/layout for non-swiper state
                const wrapper = slider.querySelector('.swiper-wrapper');
                if (wrapper) {
                    wrapper.classList.add('swiper-wrapper--disabled');
                }
            };

            const syncSliderState = () => {
                const width = window.innerWidth;

                const desiredLoop = (width < DESKTOP_BREAKPOINT) || (width >= DESKTOP_BREAKPOINT && width < 1200) || (slideCount > 3 && width < 1200);

                if (width >= DESKTOP_BREAKPOINT) {
                    if (slideCount > 3) {
                        if (!swiperInstance) {
                            initSlider();
                        } else {
                            const currentLoop = swiperInstance && swiperInstance.params ? !!swiperInstance.params.loop : null;
                            const currentSlidesPerView = swiperInstance && swiperInstance.params ? swiperInstance.params.slidesPerView : null;
                            const desiredSlidesPerView = 2;
                            if (currentLoop !== desiredLoop || currentSlidesPerView !== desiredSlidesPerView) {
                                destroySlider();
                                initSlider();
                            } else {
                                swiperInstance.update();
                            }
                        }
                        slider.classList.remove('swiper-disabled');
                        toggleControls(width);
                    } else {
                        destroySlider();
                        slider.classList.add('swiper-disabled');
                        toggleControls(width);
                    }
                } else {
                    if (!swiperInstance) {
                        initSlider();
                    } else {
                        const currentLoop = swiperInstance && swiperInstance.params ? !!swiperInstance.params.loop : null;
                        const currentSlidesPerView = swiperInstance && swiperInstance.params ? swiperInstance.params.slidesPerView : null;
                        const desiredSlidesPerView = width >= 768 ? 1.5 : 'auto';
                        if (currentLoop !== desiredLoop || currentSlidesPerView !== desiredSlidesPerView) {
                            destroySlider();
                            initSlider();
                        } else {
                            swiperInstance.update();
                        }
                    }

                    slider.classList.remove('swiper-disabled');
                    toggleControls(width);
                }
            };

            const debouncedSync = Drupal.debounce ? Drupal.debounce(syncSliderState, 150) : syncSliderState;

            syncSliderState();
            window.addEventListener('resize', debouncedSync, { passive: true });
        }
    };

})(Drupal, once);